import Typography from "@portal/components/atoms/v2/typography";
import { FC } from "react";
import { IUndesirableHoldingProps } from "./types";
import Icon from "@portal/components/atoms/icons";

const UndesirableHolding: FC<IUndesirableHoldingProps> = ({ label, value, icon }) => {
  return (
    <li className="flex justify-between items-center gap-2">
      <div className="flex space-x-2 items-center">
        {icon && <Icon name={icon} size="small" />}
        <Typography>{label}</Typography>
      </div>
      <div className="justify-self-end">
        <Typography>{value ? `${value}%` : "-"}</Typography>
      </div>
    </li>
  );
};

export default UndesirableHolding;
